











































































import { parseISO, format } from "date-fns/fp";
import { camelCase } from "lodash/fp";
import { Component, Vue, Prop } from "vue-property-decorator";

import { Entry } from "@/core/entries.interfaces";
import { entriesList } from "@/store/types";

@Component({
  filters: {
    date: function(dateTime: string) {
      if (!dateTime) {
        return "";
      }
      return format("LLL d", parseISO(dateTime));
    }
  }
})
export default class List extends Vue {
  descending = true;

  headers = ["Date", "Systolic", "Diastolic", "Pulse"];

  sortBy = "Date";

  @Prop()
  entries!: Entry[];

  get entriesSorted() {
    const sortBy = this.sortBy === "Date" ? "DateTime" : this.sortBy;
    return this.$store.getters.entries(camelCase(sortBy), this.descending);
  }

  /**
   * Ensure user's entries are populated on component create
   */
  created() {
    this.$store.dispatch({
      type: entriesList
    });
  }
}
